import { render } from "./colour-swatches.vue?vue&type=template&id=068c3d5d"
import script from "./colour-swatches.vue?vue&type=script&lang=js"
export * from "./colour-swatches.vue?vue&type=script&lang=js"

import "./colour-swatches.vue?vue&type=style&index=0&id=068c3d5d&lang=scss"

import exportComponent from "/buddy/stephen-webster/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__